__webpack_require__.p = "/my-travel-journal/";